const IMAGES = {
  ChannelitixLogo: require("./channelitixlogo.svg").default,
  MenuIcon: require("./Ellipse.svg").default,
  HighlightedMenuIcon: require("./Ellipse1.svg").default,
  UploadImage: require("./UploadImage.svg").default,
};

export default IMAGES;
